import { api } from "@/api/client";
import type { components } from "@/api/contract";
import { unwrap } from "@/api/errors";

export type ImageJob = components["schemas"]["ImageGeneration"];

/**
 * GET /v1/image/jobs/{id} — one image generation's current state. The in-chat
 * `generate_image` tool resolves immediately with a `queued` job id; we poll
 * this to know when the image has actually been produced.
 */
export async function getImageJob(id: string): Promise<ImageJob> {
  const res = unwrap(await api.GET("/v1/image/jobs/{id}", { params: { path: { id } } }));
  return res.job ?? {};
}
